import DragFileHelpMessage from "./drag-file-help-message";

export default DragFileHelpMessage;
